interface ActionItem {
  uuid: string;
  action: string; // *** Should add the exact actions
  item_id: string;
  options: any; // *** Should add the exact options for each type of actions
}

export class SimpleRuleItem {
  id: string;
  // isNew: boolean;
  actions: ActionItem[];
  logic: {
    operation: string, // *** Should add the exact actions
    "value": any[] // *** Should add the exact structure of value eg: [{  "data": "11" }, {  "data": "22" }]
    // "refresh": false
  }

  constructor(data: Partial<SimpleRuleItem> = {}) {
    this.id = data.id || ''
    this.actions = data.actions || []
    this.logic = data.logic || {
      operation: '',
      value: []
    }
  }
}